import { PHONE_REGEX_BY_ISO2 } from '../config';

/**
 * Validates a phone number produced by PhoneTextField (E.164 format).
 *
 * Single extension point for phone validation. To support more countries,
 * add their pattern to PHONE_REGEX_BY_ISO2 — consumers keep calling
 * `isValidPhoneNumber` unchanged.
 */
export const isValidPhoneNumber = (value: string): boolean =>
  Object.values(PHONE_REGEX_BY_ISO2).some((regex) => regex.test(value));
